import React from 'react';
import { AwardIcon, CheckCircle2Icon } from 'lucide-react';
import { Button } from './ui/Button';
import { SectionHeading } from './ui/SectionHeading';
import { assurances, checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="bg-ivory py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-134" data-mp="1ja0dw0krprkr">
      <div className="mx-auto max-w-3xl px-4" data-id="element-135" data-mp="1n9ipg5qp8qax">
        <SectionHeading id="pricing-title" tone="onLight" data-id="element-136" data-mp="1ncwr1brjgvhb">Scegli la tua <span className="text-gold-dark" data-id="element-137" data-mp="1s8c0zsmfe78g">opzione</span></SectionHeading>

        <article id="offerta" className="mt-10 scroll-mt-6 overflow-hidden rounded-3xl border-2 border-gold bg-navy shadow-2xl shadow-navy/40" data-id="element-138" data-mp="1x8glruud9o4h">
          <div className="border-b border-gold/30 bg-navy-light px-6 py-4 sm:px-10" data-id="element-139" data-mp="2271ktqxvu1rc">
            <span className="inline-flex items-center gap-2 rounded-full border border-gold/60 bg-gold/10 px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.14em] text-ivory" data-id="element-140" data-mp="2w9xpvgdjcur">
              <AwardIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-141" data-mp="1mhgaynz6vbbo" /> Offerta principale
            </span>
          </div>
          <div className="p-6 sm:p-10" data-id="element-142" data-mp="1hnv92kuh5x77">
            <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-143" data-mp="1cqbxjsp5vyiy">
              <div data-id="element-144" data-mp="17saeh7rqjz7h">
                <h3 className="text-2xl font-extrabold uppercase leading-tight tracking-tight text-ivory sm:text-3xl" data-id="element-145" data-mp="17stlvujrf579">{productShortName}</h3>
                <p className="mt-2 text-sm text-ivory/80" data-id="element-146" data-mp="25dg4423wkkwu">
                  Tutti i {totalVolumes} volumi + {totalBonuses} bonus esclusivi
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-147" data-mp="1vfrz8jcl1x0y">
                <span className="text-sm text-ivory/80" data-id="element-148" data-mp="1rgaqnh1v0jrk">
                  Prezzo normale: <span className="line-through decoration-gold decoration-2" data-id="element-149" data-mp="1ri3xawch33zk">{priceBefore}</span>
                </span>
                <p className="mt-2 text-xs font-bold uppercase tracking-[.14em] text-gold" data-id="element-150" data-mp="g0ukutrrhc7r">Oggi:</p>
                <p className="mt-1 whitespace-nowrap text-5xl font-extrabold leading-none tracking-tight text-gold sm:text-6xl" data-id="element-151" data-mp="hi1bu14pc4jc">{price}</p>
              </div>
            </div>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-152" data-mp="mei85im21p7i">
              Sì, voglio l&apos;Edizione Docenti
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-ivory/80" data-id="element-153" data-mp="ckrnkot1tyx3">
              {assurances.map(item => <span key={item} className="inline-flex items-center gap-1.5" data-id="element-154" data-mp="3iie829iobla">
                  <CheckCircle2Icon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-155" data-mp="3kyi5vwc2qayc" /> {item}
                </span>)}
            </div>
          </div>
        </article>
      </div>
    </section>;
}